import React from "react";

import { MenuItem, SelectChangeEvent } from "@mui/material";

import { useDevices } from "../../../AudioDeviceTestWidget/useDevices/useDevices";
import Select from "../../../Form/Select";
import ProgressBar from "../../../ProgressBar/ProgressBar";
import useStyles from "./styles";

interface Props {
  deviceTitle: string;
  label: string;
  disabled: boolean;
  deviceType: string;
  progressTitle: string;
  deviceLevel: number;
  value: string;
  setDeviceId: (value: string) => void;
}

const Device = (props: Props) => {
  const {
    deviceTitle,
    label,
    disabled,
    deviceType,
    progressTitle,
    deviceLevel,
    value,
    setDeviceId,
  } = props;
  const classes = useStyles();

  const devices = useDevices().filter((device) => device.kind === deviceType);

  return (
    <section>
      <h3 className={classes.deviceTitle}>{deviceTitle}</h3>
      <Select
        className={classes.deviceSelect}
        label={label}
        disabled={disabled}
        name={deviceTitle}
        value={value}
        onChange={(event: SelectChangeEvent<any>) => setDeviceId(event.target.value)}
      >
        {devices?.map((device) => (
          <MenuItem key={device.deviceId} value={device.deviceId}>
            {device.label}
          </MenuItem>
        ))}
      </Select>
      <div className={classes.progressSection}>
        <span className={classes.progressSectionTitle}>{progressTitle}</span>
        <ProgressBar
          position={deviceLevel}
          duration={0.1}
          progress={classes.progress}
          background={classes.background}
          style={{
            flex: "1",
            margin: "0",
            height: "16px",
            borderRadius: "4px",
          }}
        />
      </div>
    </section>
  );
};

export default Device;
